import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    handleBackground: lightColors.backgroundAlt3
};
export var dark = {
    handleBackground: darkColors.backgroundAlt3
};
